import React, { useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import classNames from 'classnames'
import RadialSpinner from 'transfix-ui/components/RadialSpinner'
import { Box, Typography, makeStyles } from 'transfix-ui/core'
import { FP_HOME } from 'apps/fleet-planner/config'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'

const useOnboardingStepLoadingStyles = makeStyles({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inner: {
    textAlign: 'center',
  },
})

export const OnboardingStepLoading = () => {
  const { trackEvent } = useFMSAnalytics()
  const classes = useOnboardingStepLoadingStyles()
  const isMounted = useRef(false)
  const history = useHistory()

  /**
   * On mount, trigger a push to history
   */
  useEffect(() => {
    let timeout: NodeJS.Timeout

    if (!isMounted.current) {
      timeout = setTimeout(() => {
        isMounted.current = true
        history.push(FP_HOME)
        trackEvent('Onboarding', 'COMPLETED_FMS_ONBOARDING')
      }, 2000)
    }

    return () => {
      clearTimeout(timeout)
    }
  }, [history])

  return (
    <Box data-test='onboarding-loading-container' className={classNames(classes.root, 'fadeInUp')}>
      <Box className={classes.inner}>
        <Box mb={1}>
          <RadialSpinner position='relative' />
        </Box>
        <Typography variant='h3' component='div' align='center'>
          Setting up your dashboard&hellip;
        </Typography>
      </Box>
    </Box>
  )
}
